import React, { useState } from 'react';
import axios from 'axios';

const PRESET_CATEGORIES = [
  'Cricket',
  'Football',
  'Badminton',
  'Tennis',
  'Basketball',
  'Volleyball',
  'Other'
];

const ItemForm = ({ onItemAdded, initialData = null }) => {
  const initialCategory = initialData?.category || '';
  const isInitialCustomCategory = Boolean(initialCategory) && !PRESET_CATEGORIES.includes(initialCategory);

  const [formData, setFormData] = useState(
    initialData || {
      name: '',
      category: '',
      total_quantity: ''
    }
  );
  const [categoryMode, setCategoryMode] = useState(
    isInitialCustomCategory ? 'custom' : 'preset'
  );
  const [selectedCategory, setSelectedCategory] = useState(
    isInitialCustomCategory ? '' : initialCategory
  );
  const [customCategory, setCustomCategory] = useState(
    isInitialCustomCategory ? initialCategory : ''
  );
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleCategoryModeChange = (e) => {
    const mode = e.target.value;
    setCategoryMode(mode);

    if (mode === 'preset') {
      setFormData((prev) => ({ ...prev, category: selectedCategory || '' }));
      return;
    }

    setSelectedCategory('');
    setFormData((prev) => ({ ...prev, category: customCategory || '' }));
  };

  const handlePresetCategoryChange = (e) => {
    const value = e.target.value;
    setSelectedCategory(value);
    setFormData((prev) => ({ ...prev, category: value }));
  };

  const handleCustomCategoryChange = (e) => {
    const value = e.target.value;
    setCustomCategory(value);
    setFormData((prev) => ({ ...prev, category: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const trimmedCategory = String(formData.category || '').trim();

    if (!trimmedCategory) {
      setError('Category is required');
      setLoading(false);
      return;
    }

    const payload = {
      ...formData,
      category: trimmedCategory
    };

    try {
      if (initialData && initialData.id) {
        await axios.put(`/api/items/${initialData.id}`, payload);
      } else {
        await axios.post('/api/items', payload);
      }
      setFormData({
        name: '',
        category: '',
        total_quantity: ''
      });
      setCategoryMode('preset');
      setSelectedCategory('');
      setCustomCategory('');
      if (onItemAdded) {
        onItemAdded();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error adding item');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h2>{initialData ? 'Update Equipment' : 'Add New Equipment'}</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Category *</label>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
            <label style={{ marginBottom: 0, fontWeight: 400 }}>
              <input
                type="radio"
                name="category_mode"
                value="preset"
                checked={categoryMode === 'preset'}
                onChange={handleCategoryModeChange}
                style={{ width: 'auto', marginRight: '6px' }}
              />
              Select Category
            </label>
            <label style={{ marginBottom: 0, fontWeight: 400 }}>
              <input
                type="radio"
                name="category_mode"
                value="custom"
                checked={categoryMode === 'custom'}
                onChange={handleCategoryModeChange}
                style={{ width: 'auto', marginRight: '6px' }}
              />
              Custom Category
            </label>
          </div>

          {categoryMode === 'preset' ? (
            <select
              value={selectedCategory}
              onChange={handlePresetCategoryChange}
              required
            >
              <option value="">Select Category</option>
              {PRESET_CATEGORIES.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          ) : (
            <input
              type="text"
              value={customCategory}
              onChange={handleCustomCategoryChange}
              required
              autoComplete="off"
              placeholder="Type your own category"
            />
          )}
        </div>

        <div className="form-group">
          <label>Equipment Name *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="e.g., Cricket Bat"
          />
        </div>

        <div className="form-group">
          <label>Total Quantity *</label>
          <input
            type="number"
            name="total_quantity"
            value={formData.total_quantity}
            onChange={handleChange}
            required
            min="1"
            placeholder="Enter quantity"
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : initialData ? 'Update Equipment' : 'Add Equipment'}
        </button>
      </form>
    </div>
  );
};

export default ItemForm;
